import { Navigate } from "react-router-dom";
import { isAuthed } from "@/lib/adminApi";

export function ProtectedRoute({ children }) {
  if (!isAuthed()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
